import { Config, fetchJSON, Languages, PROVINCE } from '@ratehub/base-ui';
import { getGICsProductShape } from '@ratehub/inv-common';


const API_ENDPOINT = `${Config.GICS_API_URL}/rates`;

async function fetchProductsForGICs(options) {
    const params = {
        language: options?.language ?? Languages.ENGLISH,
        province: options?.provinceCode ?? PROVINCE.ONTARIO,

        // default values are provided for accountType, term, balance, and Ontario
        ...(options?.accountType && { type: options.accountType }),
        ...(!isNaN(options?.term) && {
            term: Number(options.term),
        }),
        ...(!isNaN(options?.balance) && {
            investment: Number(options.balance),
        }),
        ...(options?.provider && { provider: options.provider }),
        ...(typeof options?.redeemable !== 'undefined' && { redeemable: options.redeemable }),
        ...(typeof options?.isPrioritizeSponsored === 'boolean' && {
            prioritizeSponsored: options.isPrioritizeSponsored,
        }),
        ...(options.customId && { customId: options.customId }),
    };

    const response = await fetchJSON(
        {
            url: API_ENDPOINT,
            options: {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params),
            },
        },
        'fetchProductsForGICs',
    );

    return {
        lastUpdated: response.data?.lastUpdated,
        products: response.data?.products?.map(product => 
            getGICsProductShape(
                product,
                !!options?.accountType,
            ),
        ) || [],
    };
}

export default fetchProductsForGICs;
